import { render, staticRenderFns } from "./BlockAIOptions.vue?vue&type=template&id=2925ce82"
import script from "./BlockAIOptions.vue?vue&type=script&lang=js"
export * from "./BlockAIOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports